"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var Box_1 = __importDefault(require("@mui/material/Box"));
var styles_1 = require("@mui/material/styles");
var Bar = (0, styles_1.styled)('div', {
    shouldForwardProp: function (prop) { return prop !== 'width' && prop !== 'size'; },
})(function (_a) {
    var _b;
    var theme = _a.theme, width = _a.width, _c = _a.size, size = _c === void 0 ? 'regular' : _c;
    return ({
        width: width,
        backgroundColor: (_b = theme.palette.neutral) === null || _b === void 0 ? void 0 : _b.main,
        height: size === 'regular' ? 28 : 48,
        opacity: 0.5,
    });
});
var Border = (0, styles_1.styled)('div', { shouldForwardProp: function (prop) { return prop !== 'size'; } })(function (_a) {
    var _b;
    var _c = _a.size, size = _c === void 0 ? 'regular' : _c, theme = _a.theme;
    return ({
        width: 2,
        borderRadius: 2,
        backgroundColor: (_b = theme.palette.azzurro) === null || _b === void 0 ? void 0 : _b.dark,
        height: size === 'regular' ? 32 : 54,
    });
});
var EstimateBar = function (_a) {
    var width = _a.width, size = _a.size, position = _a.position;
    return ((0, jsx_runtime_1.jsxs)(Box_1.default, __assign({ display: "flex", alignItems: "center", position: "absolute", left: position }, { children: [(0, jsx_runtime_1.jsx)(Border, { size: size }), (0, jsx_runtime_1.jsx)(Bar, { size: size, width: width }), (0, jsx_runtime_1.jsx)(Border, { size: size })] })));
};
exports.default = EstimateBar;
